import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import SweetAlert from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import customParseFormat from 'dayjs/plugin/customParseFormat';


const localizedFormat = require('dayjs/plugin/localizedFormat')
const relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat);
const MySweetAlert = withReactContent(SweetAlert)

const helpers = {
  dateFormat: date => {
    if (date) {
      return dayjs(date).format('LLL')
    }
  },
  dateFormatTimeAppointment: function (date, format = 'hh:mm A', options = {}) {
    if (options !== undefined) {
      if ('language' in options) {
        dayjs.locale(options?.language || 'en')
      }
    }
    return dayjs(date).format(format)
  },
  preventDecimal: event => {
    if (event) {
      let char = String.fromCharCode(event.which)
      if (!/[0-9]/.test(char)) {
        event.preventDefault()
      }
    }
  },
  remainingTimeFromNow: date => {
    if (date) {
      return dayjs(date).fromNow()
    }
  },

  isVarCharNumber: event => {
    const char = String.fromCharCode(event.which)
    if (!/^[a-zA-Z0-9]*$/.test(char)) {
      event.preventDefault()
    }
  },
  isInputNumber: event => {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault()
    }
  },

  alertFunction: (title, item, changeFunction, deleteIcon) => {
    MySweetAlert.fire({
      // title: <h3>{title}</h3>,
      html: <strong>{title}</strong>,
      icon: deleteIcon ? 'error' : 'warning',
      showConfirmButton: 'Okay',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        changeFunction(item)
      }
    })
  },
  priceFormat: price => {
    return price?.toLocaleString('en-US')
  },
  NumberInputNew: event => {
    if (event) {
      if (
        !['Backspace', 'Delete', 'Tab'].includes(event.key) &&
        !/[0-9]/.test(event.key)
      ) {
        event.preventDefault()
      }
    }
  },
  downloadFile: url => {
    if (isEmpty(url)) {
      alert('Invalid URL')
      return false
    }
    const parts = url.split('/')
    const filename = parts[parts.length - 1]
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(xhr.response)
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }
    xhr.send()
  },
  isValidLatitude: latitude => {
    return latitude >= -90 && latitude <= 90
  },
  isValidLongitude: longitude => {
    return longitude >= -180 && longitude <= 180
  },
  getFileSize: file => {
    return (file?.size / (1024 * 1024)).toFixed(2)
  },
  generateMapURL: property => {
    if (isEmpty(property.location)) return ''
    const baseURL = 'https://www.google.com/maps?q='
    const propertyLocation = [
      property.location.coordinates[1],
      property.location.coordinates[0]
    ]
    return `${baseURL}${propertyLocation.join(',')}`
  },
  maxInputNumber: (max, e) => {
    if (e?.target.value.length >= max) {
      e.preventDefault()
    }
  },
  isInputChar: event => {
    const char = String.fromCharCode(event.which)
    if (!/^[a-zA-Z]$/.test(char)) {
      event.preventDefault()
    }
  },
  isSaudi:() =>{
   const saudiContry = localStorage.getItem('country') === 'Saudi' ? true: false;
   return saudiContry;
  },
  NumberInputWithDotNew :(event) => {
    if (!event) return;
  
    const char = event.key; // Use event.key for better clarity
    const value = event.target.value;
  
    // Allow navigation keys, backspace, and delete
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (allowedKeys.includes(char)) return;
  
    // Block invalid input: non-numeric characters and multiple dots
    if (!/^\d$/.test(char) && char !== '.' || (char === '.' && value.includes('.'))) {
      event.preventDefault();
    }
  },
  parseAndFormatDate: (date = '', format = undefined, fallback = new Date()) => {
    return date && dayjs(date, format).isValid()
        ? new Date(dayjs(date, format).toISOString())
        : fallback;
  }
}

export default helpers
